
export default {
  Close: '關 閉',
  Confirm: '確定',
  header: {
    Home: '首頁',
    MyOrder: '我的訂單',
    Login: '登錄',
    changeYourPassword: '修改密碼',
    logout: '退出'
  },
  Announcement: '公告',
  WeChatTitle: '秦始皇帝陵博物院微信公衆號',
  PleaseUseWeChat: '請使用微信掃描上方公衆號二維碼',
  CountDown: '倒數計時',
  CountDownComplete: '关闭',
  buyTicket: {
    selectAVisitDate: '選擇參觀日期',
    selectAVisitTime: '請選擇檢票進場時段',
    selectTicketType: '選擇票類',
    maxNum: `一筆訂單最多購買&valItem張門票`,
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    Sunday: '星期日',
    notBooking: '不可預約',
    ticketBalance: '餘量',
    productName: '產品名稱',
    ticketType: '票種',
    ticketingInstructions: '購票須知',
    PleaseRead: '請仔細閱讀須知',
    IRead: '我已詳細閱讀，繼續預定',
    UnitPrice: '單價',
    Quantity: '數量',
    noDataAvailable: '暫無數據',
    telephoneConsultation: '電話諮詢',
    onlineConsultation: '在線諮詢',
    weChatOfficialAccount: '微信公衆號',
    Reminder: '提示',
    totalPrice: '總價',
    placeOrder: '提交訂單',
    ticketingInstructions: '購票須知',
    Total: '合計',
    totalNum: '共&valItem張',
    TotalPrice: '總價',
    LatestAnnouncement: '最新公告',
    viewMore: '查看更多'
  },
  // 购票进程
  TicketingProcessObj: {
    TicketingProcess: '购票进程',
    TimeOut: '選擇檢票進場時段',
    selectTicketType: '選擇票類',
    FillOrder: '填寫訂單信息',
    OrderPayment: '訂單支付',
    Completed: '完成'
  },
  // 账号密码登录注册修改
  LoginObj: {
    LoginAndPassword: '賬號密碼登錄',
    LoginCode: '驗證碼登錄',
    PleaseNumber: '請輸入您的手機號',
    PleasePassword: '請輸入密碼',
    Change: '換一換',
    PleaseCode: '請輸入驗證碼',
    PleaseAgain: '請再次輸入密碼',
    LogIn: '立即登錄',
    SignUpNow: '立即註冊',
    ForgotPassword: '忘記密碼',
    AgreeDisclaimer: '同意會員條款和免責聲明',
    GetVerificationCode: '獲取驗證碼',
    Reacquire: '重新獲取',
    NoAccount: '沒有賬號',
    ChangePassword: '修改密碼',
    Logout: '退出',
    ExistingAccount: '已有賬號',
    ImmediatelyFind: '立即找回'
  },
  // 下单页
  FillOrder: {
    FillOrder: '填寫訂單信息',
    FillOrderTitle: '秦始皇帝陵博物院購票實行實名制，所有觀衆需錄入身份信息方可預定',
    VisitDate: '參觀日期',
    Name: '姓名',
    DocumentType: '證件類型',
    IDCard: '身份證',
    Passport: '護照',
    Others: '其他',
    IDNumber: '證件號',
    SpecialIDType: '特殊證件類型',
    SpecialIDNumber: '特殊證件號',
    DeleteThisContact: '刪除此聯繫人',
    PleaseYourName: '請輸入姓名',
    PleaseIDNumber: '請輸入證件號',
    PleaseSpecialIDNumber: '請輸入特殊證件號',
    PleaseenterContact: '請輸入聯繫人手機號碼',
    Delete: '刪除',
    information: '聯繫人信息',
    informationSub: '（請準確填寫，以免無法接收訂單信息）',
    ContactPhoneNumber: '聯繫手機號',
    TotalAmount: '總金額',
    BuyNow: '立即購買',
    ConfirmReminder: '確認提示',
    DoubleConfirm: '再次確認',
    Confirmed: '確認無誤',
    BeforeBy: '立即購買前，請確認身份信息是否輸入正確，以免影響您的參觀體驗。',
    OutByOrder: '温馨提示',
    Mausoleum: '秦始皇帝陵博物院歡迎您！溫馨提示：每日系統維護，維護時間爲：23:30至次日02：30，在此期間暫停售票服務。',
    Reminder: '提示信息',
    PleaseCorrectInformation: '請填寫正確的信息',
    AgeDiscountRange: '您的年齡不符合優惠範圍內',
    InvalidIDNumber: '身份證號碼無效',
    productName: '產品名稱',
    ticketType: '票种',
    Quantity: '票種',
    UnitPrice: '單價'
  },
  back: '返回',
  // 支付
  payOrder: {
    OrderQuantity: '訂單數量',
    NumberProducts: '商品數量',
    OrderInformation: '訂單信息',
    VisitTime: '參觀時間',
    TicketName: '票名稱',
    ticketType: '票種',
    UnitPrice: '單價',
    Quantity: '數量',
    PaymentOrderSeconds: '支付訂單剩餘時間:&item1分&item2秒',
    PleaseComplete: '請及時完成，否則訂單將自動取消',
    Alipay: '支付寶',
    WeChat: '微信',
    PleaseQRcodepay: '請掃碼支付',
    Orderpaymenttimeout: '訂單支付超時，請重新下單！',
    goFillOrderL: '去下單',
    Backtohome: '返回首頁',
    Checkorder: '查看訂單',
    Refund: '退款',
    TicketReplacement: '補票',
    ChangeTicket: '改簽',
    RefundProgress: '退款中'
  },
  Cancel: '取消',
  Backtohome: '返回首頁',
  Checkorder: '查看訂單',
  LatestAnnouncement: '最新公告',
  PreviousPage: '上一頁',
  NextPage: '下一頁',
  ReleaseTime: '發佈時間',
  MyOrder: {
    MyOrder: '我的訂單',
    OrderCenter: '訂單中心',
    All: '全部',
    Completed: '已完成',
    ToBePaid: '待支付',
    OrderNumber: '訂單編號',
    VisitorIDNumber: '出行人證件號',
    Inquire: '查詢',
    Reset: '重置',
    OrderPlacementTime: '下單時間',
    Contactphonenumber: '聯繫人手機號',
    OrderStatus: '訂單狀態',
    Startdate: '開始日期',
    EndDate: '結束日期',
    VisitTime: '參觀時間',
    Visitdate: '出遊日期',
    VisitTimePeriod: '參觀時段',
    Actualpaymentpaymentmethod: '實付款/支付方式',
    Operating: '操作',
    OrderDetails: '訂單詳情',
    Paymentquery: '支付查詢',
    Expandall: '展開所有',
    CreationDate: '創建時間',
    Fullorderamount: '訂單全額',
    Fullpayment: '實付全額',
    Fullrefund: '退款全額',
    Handlingfee: '手續費',
    Ticketnumber: '票號',
    TicketcheckingQRcode: '驗票二維碼',
    Effectivedate: '有效日期',
    Effectivetime: '有效時間',
    Numberofpeople: '人數',
    Numberoftimes: '次數',
    Ticketcollectiondate: '取票日期',
    Numberofprints: '打印次數',
    Numberofticketschecked: '已驗次數',
    Ticketstatus: '票狀態',
    Checkingrecords: '檢票記錄',
    Uncollectedticket: '未取票',
    Void: '作廢',
    Checkinrecords: '檢票記錄',
    Close: '關閉',
    Checkininformation: '檢票信息',
    Ticketidentificationnumber: '檢票識別號',
    Checkindate: '檢票日期',
    Checkintime: '檢票時間',
    Checkpointname: '檢票點名稱',
    Nodataavailable: '查無數據',
    Price: '價格',
    Handlingfee: '手續費',
    selectText: '已選&item1張，合計',
    selectText2: '扣除手續費',
    selectVisitTime: '請選擇參觀時間'
  },
  orderStatus: {
    Pendingreview: '待審覈',
    Closed: '已關閉',
    Issued: '已出票',
    Tobepaid: '待支付',
    Refunded: '已退款',
    Completed: '已完成'
  },
  status: '狀態',
  Ticketcollectionstatus: '取票狀態',
  Pickedup: '已取票',
  NotPickup: '未取票',
  Ticketcheckintype: '檢票類型',
  Normalticketcheckin: '正常檢票',
  Freeadmissionticketcheckin: '免票檢票',
  Mandatoryticketcheckin: '強制檢票',
  Ticketcheckmedia: '檢票介質',
  Ticketidentificationnumber: '檢票識別號',
  Checkindate: '檢票日期',
  Checkintime: '檢票時間',
  Checkpointname: '檢票點名稱',
  el: {
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共{total}条',
      pageClassifier: '页'
    }
  }
}
